import { DrupalNodeExternalResource } from "@/types"
import { PageInterface } from "@/components/page/PageInterface"
import { MetadataRoute } from "next"
import { ExternalResourceBase } from "@/components/page/external-resource"
import { ApiViewer } from "@/components/app/api/ApiViewer"



export type OpenApiJsonResourceContext = {

}

export class OpenApiJsonResource extends ExternalResourceBase<OpenApiJsonResourceContext>  {
  private readonly url: string
  public readonly useDocumentSidebar = false
  public readonly useTableOfContents = false

  constructor(public readonly node: DrupalNodeExternalResource) {
    super()
    this.url = node.field_resource_url.uri;
  }

  get basepath(): string {
    return this.node.path.alias
  }

  async getPageTitle(slug: string): Promise<string> {
      return this.node.title
  }


  async getContext(): Promise<OpenApiJsonResourceContext> {
    return {}
  }

  async getPageContent(props: PageInterface<DrupalNodeExternalResource>): Promise<JSX.Element> {
    return <div className="container mx-auto p-5">
        <ApiViewer url={this.url} />
      </div>
  }

  async buildSitemap(baseUrl:string): Promise<MetadataRoute.Sitemap> {

    return [{
        url: baseUrl + this.basepath,
        lastModified: new Date(),
        changeFrequency: 'weekly',
        priority: 0.8,
      }];
  }
}